var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("error-page", [
    _c(
      "div",
      [
        _c("h1", [_vm._v("404")]),
        _vm._v(" "),
        _c("h2", [_vm._v(_vm._s(_vm.$t("errors.404.subtitle")))]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.$t("errors.404.description")))]),
        _vm._v(" "),
        _c(
          "router-link",
          { attrs: { to: "/" } },
          [
            _c("x-button", { staticClass: "md-raised md-primary dark" }, [
              _vm._v(_vm._s(_vm.$t("buttons.home")))
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }